import cn from 'classnames';
import React, {FC} from 'react';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import AppPopup from '../../Popup/AppPopup';
import styles from './AppLoader.module.scss';
import AppLoaderContent from './AppLoaderContent';

interface IProps {
    loaderText: string;
    isTransparent: boolean;
}
const AppLoader: FC<IProps> = ({loaderText, isTransparent}) => {
    const overlayClassName = cn(styles.Overlay, {[styles.Transparent]: isTransparent});
    const localizedStrings = getLocalizedStrings();

    return (
        <AppPopup
            contentLabel={localizedStrings[localizationKeys.GLOBAL_LOADER_DEFAULT_TEXT_MAIN]}
            isOpen
            className={styles.AppLoaderContainer}
            overlayClassName={overlayClassName}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            {!isTransparent && <AppLoaderContent loaderText={loaderText} />}
        </AppPopup>
    );
};

export default AppLoader;
